import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import axios, { AxiosRequestConfig } from 'axios';

import { IExperienceRead } from './interfaces';
import { experienceKeys } from './queryKeys';
import {
	HydraCollectionResponse,
	HydraPaginationQueryParams
} from '../interfaces';

interface IGetExperiencesConfig extends AxiosRequestConfig {
	params?: IGetExperiencesQueryParams;
}

export type IGetExperiencesQueryParams = HydraPaginationQueryParams & {
	homepageHighlighted?: boolean;
    type?: string
};

export const getExperiences = async (
	config?: IGetExperiencesConfig
): Promise<HydraCollectionResponse<IExperienceRead>> => {
	return await axios
		.get(`/api/v2/shop/experiences`, {
			...config
		})
		.then(response => {
			return Promise.resolve(
				response.data as HydraCollectionResponse<IExperienceRead>
			);
		})
		.catch(error => {
			console.error('Error getting experiences: ', error);
			return Promise.reject(error);
		});
};

const defaultOptions: IUseGetExperiencesQueryOptions = {
	refetchOnWindowFocus: false
};

type IUseGetExperiencesQueryOptions = UseQueryOptions<
	HydraCollectionResponse<IExperienceRead>,
	unknown,
	HydraCollectionResponse<IExperienceRead>
>;

export function useGetExperiencesQuery(
	config?: IGetExperiencesConfig,
	options?: IUseGetExperiencesQueryOptions
) {
	return useQuery(
		experienceKeys.list({ ...config?.params }),
		() => {
			return getExperiences(config);
		},
		{
			...(defaultOptions as any),
			...options
		}
	);
}
